import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/antd.css";
import "react-loading-skeleton/dist/skeleton.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import "./index.css";

import App from "./App";
import { ToastContainer } from 'react-toastify';

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AxiosProvider } from "./lib/AxiosProvider";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<AxiosProvider>
		<QueryClientProvider client={queryClient}>
			<App />
			<ToastContainer />
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</AxiosProvider>
);
